<template>
  <div v-if="hasRow">
    <h4 class="pull-left">All Rows</h4>
    <div class="action-button pull-right" style="margin-top: -20px">
      <div class="style-new-icon">
          <i class="fa fa-gift" v-on:click="showInfoPopUp" style="font-size:25px;" aria-hidden="true" title="New Features!"></i>
      </div>
      <button  class="btn btn-primary" style="margin-top:-10px" type="button" @click="OpenPOP()">Add Message</button>
    </div>
    <table class="table table-striped" style="width=100%">
                 <tbody v-if="allRows[0].configNew">
                  <tr v-bind:key="key" v-for="(row, key) in allRows[0].configNew">
                    <td style='width: 20%;'>{{row['title']}}</td>
                    <td style="width:3%">
                      <i @click="OpenPOP(row['title'], row)" class="fa fa-pencil" aria-hidden="true"></i>
                    </td>
                    <td style="width:3%">
                      <i @click="deleteMessage(row['title'], row)" class="fa fa-times-circle" aria-hidden="true"></i>
                    </td>
                    <td>
                        <table class="" style="width=100%" v-if="row['language'] && Object.keys(row['language']).length">
                            <tr v-bind:key="key" v-for="(langRow, key) in row['language']">
                              <td style="width:10%">{{langRow['langName']}}</td>
                              <td> {{langRow.message}}</td>
                            </tr>
                        </table>
                          <table class="" style="width=100%" v-if="row['country'] && Object.keys(row['country']).length">
                            <tr v-bind:key="key" v-for="(countryRow, key) in row['country']" style="border-bottom: 3px solid lightgray;">
                              <td style="width:12%;  background-color: #e8e8e8;">{{countryRow['country']}}</td>
                              <td style="width:88%;">  
                                <table class="" style="width=100%" v-if="countryRow['languages'] && Object.keys(countryRow['languages']).length">
                                    <tr v-bind:key="key" v-for="(languageRow, key) in countryRow['languages']">
                                      <td style="width:12%;  background-color:#f3f2f2;">{{languageRow['langName']}}</td>
                                      <td> {{languageRow['message']}}</td>
                                    </tr>
                                </table>
                                </td>
                            </tr>
                        </table>
                    </td>
                  </tr>        
                  
                </tbody>
               </table>
      <div class="modal-backdrop" v-if="showNewFeaturePrompt">
        <div class="modal new-feature" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" style="height: 415px; width: 518px;">
          <header class="modal-header">
            <div class="header-style">
              <h3>New Features !</h3>
              <i v-on:click="closeNewFeatureModal" class="fa fa-close" style="font-size:27px;color:red" title="Close"></i>
            </div>
          </header>
          <section class="modal-body">
            <div class="style-section">
              <h4 class="style-button-section"><b>Button</b></h4>
              <div>We can now add buttons for message instead of asking the user to type the numbers.</div>
              <div class="style-template-text"><b>Template to use button:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForButton }}</span>
              <h4 class="style-list-section"><b>List</b></h4>
              <div>We can support lists instead of buttons whenever the user has more than 3 options to be selected.</div>
              <div class="style-template-text"><b>Template to use list:- </b></div>
              <div class="style-select-options">Please select one of the following options :- </div> 
              <span>{{ showTextInfoForList }}</span>
            </div>
          </section>
        </div>
      </div>
    <!-- <table class="table table-striped" style="display:none">
      <thead>
        <th class="text-center">Name</th>
        <th class="text-center">{{primaryLangText}}</th>
        <th class="text-center">{{secondaryLangText}}</th>        
        <th>Edit</th>
        <th>Delete</th>
      </thead>
      <tbody v-if="allRows[0].config">
        <tr v-for="(row, key) in primaryLanguageData">
          <td>{{key}}</td>
          <td align="center">{{primaryLanguageData[key]}}</td>
          <td align="center">{{secondaryLanguageData[key]}}</td>
          <td>
           <i @click="OpenPOP(primaryLanguageData[key], secondaryLanguageData[key], key)" class="fa fa-pencil" aria-hidden="true"></i>
          </td>
          <td>
            <i @click="deleteMessage(primaryLanguageData[key], secondaryLanguageData[key], key)" class="fa fa-times-circle" aria-hidden="true"></i>
          </td>
        </tr>        
      </tbody>
      <tbody v-if="!allRows[0].config">
        <tr>
          <td colspan="5" align="center">No result found</td>          
        </tr>
      </tbody>
    </table> -->
  
  <div>
    <transition name="modal-fade"  class="modal-fade">
      <div class="modal-backdrop"  v-if="showModal" id="myModal">
        <form class="form-horizontal" @submit.prevent="addOrUpdate" action="#" method="post">
          <div class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
            <header class="modal-header">
              <slot name="header">           
                Add Application Messages
                <div class="closeButton">
                  <!-- <button type="button" class="btn" @click="close">Close</button> -->
                </div>
              </slot>
            </header>
            <section class="modal-body">
              <slot name="body">            
                  <div class="row">
                    <div class="form-group">
                      <label for="campaign" class="col-sm-3 control-label">Campaign</label>
                      <div class="col-sm-9">
                        <input type="text" class="form-control" id="campaign" name="campaign" placeholder="Campaign" disabled v-model="gRowObj.campaign">
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="Message" class="col-sm-3 control-label">Message Name</label>
                      <div class="col-sm-9">
                        <input type="text" class="form-control" id="Message" name="Message" placeholder="Message Name" v-model="gRowObj.message"></div>
                    </div>
                    <div class="form-group">
                      <label for="primarylanuage" class="col-sm-3 control-label">{{primaryLangText}}</label>
                      <div class="col-sm-9">
                        <textarea type="text" class="form-control" id="primarylanguage" name="primarylanguage" placeholder="Primary Language" v-model="gRowObj.primaryLanguageMsg"></textarea></div>
                    </div>
                    <div class="form-group">
                      <label for="secondarylanguage" class="col-sm-3 control-label">{{secondaryLangText}}</label>
                      <div class="col-sm-9">
                        <textarea type="text" class="form-control" id="secondarylanguage" name="secondarylanguage" placeholder="Secondary Language" v-model="gRowObj.secondaryLanguageMsg"></textarea></div>
                    </div>
                    <div class="form-group">
                      <div class="col-sm-offset-2 col-sm-10">
                        <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                        <input type="submit" class="btn btn-primary margin-left-20px" value="Submit">
                      </div>
                    </div>
                </div>  
              </slot>    
            </section>      
          </div>
        </form>
      </div>
    </transition>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
  </div>
  </div>
</template>
<script>
import api from '../../../utils/api'
export default {
  name: 'app-all-rows',
  props: ['allRowsObj'],
  watch: {
    allRowsObj () {
      console.log('watch', this.allRowsObj)
      this.allRows = this.allRowsObj
      // var domainname = window.location.hostname
      if (this.allRows.length > 0) {
        if (this.allRows[0].config) {
          // this.primaryLanguageData = Object.assign({}, this.allRows[0].config[this.domain[domainname].primaryLanguage])
          // this.secondaryLanguageData = Object.assign({}, this.allRows[0].config[this.domain[domainname].secondaryLanguage])
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          console.log(this.primaryLangText)
          return Object.keys(this.allRows).length
        } else {
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          return (this.allRows).length + 1
        }
      }
    },
    gRowObj (v1, v2) {
      console.log('v1 ', v1)
      console.log('v2 ', v2)
    }
  },
  methods: {
    /**
     * @function removeStage
     * @description delete a stage from the app flow
     * @param {string} stageName - name of the stage
     */
    OpenPOP (message, row) {
      // this.showModal = true
      console.log('sheet id', this.$route.query.id)
      this.gRowObj.campaign = this.$route.query.sheetTitle
      this.gRowObj.id = this.$route.query.id
      // this.gRowObj.primaryLanguageMsg = primary
      // this.gRowObj.secondaryLanguageMsg = secondary
      if (row && Object.keys(row)) {
        this.gRowObj.rowObj = JSON.parse(JSON.stringify(row))
      } else {
        this.gRowObj.rowObj = this.allRows[0].newRecord
      }
      this.gRowObj.message = message
      if (row) {
        this.gRowObj.displayText = row.displayText
        this.gRowObj.isCustomMessage = row.isCustomMessage
      } else {
        this.gRowObj.displayText = undefined
        this.gRowObj.isCustomMessage = false
      }
      // console.log('id', id)
      this.$emit('add-message', {
        gRowObj: this.gRowObj,
        // primaryLangText: this.primaryLangText,
        // secondaryLangText: this.secondaryLangText,
        allRows: this.allRows,
        loading: this.loading
      })
    },
    showInfoPopUp () {
      this.showNewFeaturePrompt = true
    },
    closeNewFeatureModal () {
      this.showNewFeaturePrompt = false
    },
    close () {
      this.showModal = false
    },
    removeStage (stageName) {
      this.$emit('remove', stageName)
    },
    deleteMessage (message, id, row) {
      console.log('sheet id', this.$route.query.id)
      this.gRowObj.campaign = this.$route.query.sheetTitle
      this.gRowObj.id = this.$route.query.id
      // this.gRowObj.primaryLanguageMsg = primary
      // this.gRowObj.secondaryLanguageMsg = secondary
      this.gRowObj.message = message
      if (row && Object.keys(row)) {
        this.gRowObj.rowObj = JSON.parse(JSON.stringify(row))
      }
      console.log('del sent', this.gRowObj)
      this.$emit('delete-message', {
        gRowObj: {
          campaign: this.$route.query.sheetTitle,
          id: this.$route.query.id,
          // primaryLanguageMsg: primary,
          // secondaryLanguageMsg: secondary,
          message: message
        },
        primaryLangText: this.primaryLangText,
        secondaryLangText: this.secondaryLangText,
        allRows: this.allRows
      })
    },
    /**
     * @function editStage
     * @description edit a stage on the app flow
     * @param {string} stageName - name of the stage
     */
    editStage (stageName) {
      this.$emit('edit', stageName)
    },
    upsert (allRows) {
      console.log('aro', this.allRowsObj)
      console.log('ar', this.allRows)
      this.allRows = allRows
      console.log('rows data', this.allRows)
      console.log('rows data', allRows)
      // var domainname = window.location.hostname
      // this.primaryLanguageData = this.allRows[0].config.eng
      // console.log('primarylanguage', this.primaryLanguageData)
    },
    simplifyConfigData () {
      var finalData = {}
      this.allRows[0].configNew.forEach(item => {
        if (item.language) {
          item.language.forEach(function (lang) {
            if (!finalData[lang.langShortcode]) {
              finalData[lang.langShortcode] = {}
            }
            finalData[lang.langShortcode][item.name] = lang.message
          })
        }
        if (item.country) {
          finalData[item.name] = {}
          item.country.forEach(function (country) {
            if (!finalData[country.country]) {
              finalData[item.name][country.country] = {}
            }
            finalData[item.name][country.country] = {}
            country.languages.forEach(function (language) {
              finalData[item.name][country.country][language.langCode] = language['message']
            })
          })
        }
        if (this.allRows[0].campaign === 'APP_LAUNCH') {
          finalData[item.name].displayText = item.displayText
          finalData[item.name].isCustomMessage = item.isCustomMessage
        }
      })
      this.allRows[0].config = finalData
    },
    deleteMsg (messageData) {
      this.showModal = false
      let trimmedObj = {}
      console.log('call deletemsg function')
      console.log('msgData ', messageData)
      this.gRowObj.campaign = messageData.gRowObj.campaign
      this.gRowObj.id = messageData.gRowObj.id
      // this.gRowObj.primaryLanguageMsg = messageData.gRowObj.primaryLanguageMsg
      // this.gRowObj.secondaryLanguageMsg = messageData.gRowObj.secondaryLanguageMsg
      this.gRowObj.message = messageData.gRowObj.message
      // var domainname = window.location.hostname
      this.allRows = messageData.allRows
      let indexLangUpdate = this.allRows[0].configNew.findIndex(x => x.title === messageData.gRowObj.message)
      if (indexLangUpdate >= 0) {
        delete this.allRows[0].configNew[indexLangUpdate]
      }
      console.log('----Config', this.allRows[0])
      console.log('----Config', this.allRows[0])
      this.simplifyConfigData()
      // delete this.allRows[0].config[this.domain[domainname].primaryLanguage][messageData.gRowObj.message]
      // delete this.allRows[0].config[this.domain[domainname].secondaryLanguage][messageData.gRowObj.message]
      this.gRowObj.campaign = this.gRowObj.campaign.toUpperCase()
      this.gRowObj.config = this.allRows[0].config
      trimmedObj = this.trimJsonObj(this.gRowObj)
      console.log('trim object', trimmedObj)
      trimmedObj.campaignType = this.allRows[0].campaignType || 'generic'
      if (this.allRows[0].campaignType) {
        trimmedObj.messageType = this.allRows[0].messageType
      }
      const newRowObj = {
        id: trimmedObj.id,
        campaign: trimmedObj.campaign,
        config: trimmedObj.config,
        data: trimmedObj
      }
      console.log('data from saving', newRowObj)
      let params = {}
      params.newRow = Object.assign({}, newRowObj)
      let apiToCall = 'updateMessages'
      let returnMessages = 'Messages deleted successfully.'
      // this.$emit('close')
      this.performKeywordOperation(newRowObj, apiToCall, returnMessages)
      params.newRow = this.primaryLanguageData
    },
    addOrUpdate (e) {
      console.log(e)
      this.showModal = true
      console.log('inside addOrUpdate function')
      console.log('allrows data', this.allRows)
      // console.log(this.gRowObj)
      this.submitted = true
      this.keywordExistError = false
      var domainname = window.location.hostname
      this.primaryLanguageData = [this.domain[domainname].primaryLanguage]
      this.secondaryLanguageData = [this.domain[domainname].secondaryLanguage]
      // this.$v.$touch()
      // if (this.$v.$invalid) {
      //   return
      // }
      let queryParams = {
        selector: {
          id: this.gRowObj.id,
          campaign: this.gRowObj.campaign,
          message: this.gRowObj.message,
          config: {
            [this.gRowObj.message]: {
              [this.domain[domainname].primaryLanguage]: this.gRowObj.primaryLanguageMsg,
              [this.domain[domainname].secondaryLanguage]: this.gRowObj.secondaryLanguageMsg
            }
          },
          isdeleted: false
        }
      }
      if (this.allRows[0].hasOwnProperty('config')) {
        // this.allRows[0].config[this.domain[domainname].Name][this.gRowObj.message] = this.gRowObj.message
        this.allRows[0].config[this.domain[domainname].primaryLanguage][this.gRowObj.message] = this.gRowObj.primaryLanguageMsg
        this.allRows[0].config[this.domain[domainname].secondaryLanguage][this.gRowObj.message] = this.gRowObj.secondaryLanguageMsg
      } else {
        this.allRows[0].config = { [this.domain[domainname].primaryLanguage]: {
          [this.gRowObj.message]: this.gRowObj.primaryLanguageMsg
        },
          [this.domain[domainname].secondaryLanguage]: {
            [this.gRowObj.message]: this.gRowObj.secondaryLanguageMsg
          }
        }
      }
      // this.allRows[0].config = this.gRowObj.config
      console.log('check exit param', queryParams)
      api.buildRequest('checkMessageExists', 'POST', queryParams)
      .then(response => {
        console.log(response.data.payload)
          // console.log(response.data.payload.facilities)
        if (response.status === 200) {
          if (response.data.payload === null) {
            let apiToCall = 'updateMessages'
            let messages = ''
            console.log(response.data.payload)
            console.log('updateMessages')
            this.loading = true
            let trimmedObj = {}
            this.gRowObj.id = this.gRowObj.id
            this.gRowObj.campaign = this.gRowObj.campaign.toUpperCase()
            this.gRowObj.message = this.gRowObj.message
            this.gRowObj.config = this.allRows[0].config
            // this.gRowObj.config = this.allRows[0].config.push(this.gRowObj.config)
            trimmedObj = this.trimJsonObj(this.gRowObj)
            // if (this.gRowObj.appmessagename === '' || this.gRowObj.appmessagename === null) {
            //   delete trimmedObj.appmessagename
            // }
            // if (this.gRowObj.campaign === '' || this.gRowObj.campaign === null) {
            //   delete trimmedObj.campaign
            // }
            console.log('trim object', trimmedObj)
            const newRowObj = {
              id: trimmedObj.id,
              campaign: trimmedObj.campaign,
              config: trimmedObj.config,
              data: trimmedObj
            }
            if (this.allRows[0].messageType) {
              newRowObj.messageType = this.allRows[0].messageType
            }
            console.log('data from saving', newRowObj)
            let params = {}
            params.newRow = Object.assign({}, newRowObj)
            apiToCall = 'updateMessages'
            this.performKeywordOperation(newRowObj, apiToCall, messages)
            // delete params.updatedRow
            this.showModal = false
          } else {
            this.keywordExistError = true
          }
        }
      }).catch(({ response }) => {
        this.loading = false
        this.$swal({
          type: 'error',
          text: response ? response.data.payload.message : 'An error occurred'
        })
      })
    },
    performKeywordOperation (params, apiToCall, message) {
      // console.log(`params=${JSON.stringify(params)}`)
      api.buildRequest(apiToCall, 'POST', params)
        .then(response => {
          if (response.status === 200) {
            console.log('Response', response)
            this.loading = false
            // this.allRows.shift()
            // this.allRows[0] = response.data.payload.Data
            // this.allRows[0].pop(response.data.payload.Data)
            console.log('rows', this.allRows[0])
            this.$emit('refresh-message')
            this.$swal({
              type: 'success',
              text: message
            })
          } else {
            console.log('something went wrong')
          }
        }).catch(({ response }) => {
          this.loading = false
          this.$swal({
            type: 'error',
            text: response ? response.data.payload.message : 'An error occurred'
          })
        })
    },
    trimJsonObj (obj) {
      const trimmedObj = {}
      Object.keys(obj).forEach(function (key) {
        console.log(key, obj[key])
        trimmedObj[key] = obj[key]
        if (obj[key] !== undefined && typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim()
        }
      })
      delete trimmedObj._id
      return trimmedObj
    }
  },
  computed: {
    hasRow () {
      // for (let key in this.allRows.config) {
      //   console.log('key', key)
      // }
      // console.log('Given Data', this.allRows)
      console.log('domain name', window.location.hostname)
      // var domainname = window.location.hostname
      if (this.allRows.length > 0) {
        if (this.allRows[0].config) {
          // this.primaryLanguageData = this.allRows[0].config[this.domain[domainname].primaryLanguage]
          // this.secondaryLanguageData = this.allRows[0].config[this.domain[domainname].secondaryLanguage]
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          // console.log(this.primaryLangText)
          return Object.keys(this.allRows).length
        } else {
          // this.primaryLangText = this.domain[domainname].primaryLangText
          // this.secondaryLangText = this.domain[domainname].secondaryLangText
          console.log(this.allRows.length)
          return (this.allRows).length
        }
      }
      // this.primaryLangText = this.domain[domainname].primaryLangText
      // this.secondaryLangText = this.domain[domainname].secondaryLangText
      console.log('all rows count', (this.allRows).length)
      return (this.allRows).length + 1
    }
  },
  data () {
    return {
      showTextInfoForButton: '{{item1}} {{item2}} {{item3}}',
      showTextInfoForList: '{{item1}} {{item2}} {{item3}} {{item3}} [[ListButtonText]]',
      showNewFeaturePrompt: false,
      showModal: false,
      allRows: this.allRowsObj,
      primaryLangText: {},
      secondaryLangText: {},
      primaryLanguageData: {},
      secondaryLanguageData: {},
      gRowObj: {
        id: null,
        campaign: '',
        message: '',
        primaryLanguageMsg: '',
        secondaryLanguageMsg: '',
        config: {}
      },
      domain: {
        'localhost': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        },
        'dashboard.mynivi.in': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'india-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'hi',
          primaryLangText: 'English',
          secondaryLangText: 'Hindi'
        },
        'eu-dashboard-staging.herokuapp.com': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        },
        'dashboard.mynivi.ke': {
          primaryLanguage: 'eng',
          secondaryLanguage: 'swa',
          primaryLangText: 'English',
          secondaryLangText: 'Swahili'
        }
      }
    }
  }
}
</script>
<style>
.multiline
 {
  white-space: pre-wrap;
}
.strUppercase {
  text-transform: capitalize;
}
.text-center {
  text-align: center;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
td {
  border-bottom: 1px solid #e8e8e8;
  padding: 7px;
}

.modal {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);    
  height:600px;    
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: inline-block;
}

.modal-header {
  border-bottom: 1px solid #eeeeee;
  text-align: center;
  font-size: 18px;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  min-height: 400px;    
}

.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #0D9488;
  background: transparent;
}

.btn-green {
  color: white;
  background: #0D9488;
  border: 1px solid #0D9488;
  border-radius: 2px;
}
.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease
}
.closeButton {
  position:absolute;
  left:92%;
  top:-1%;
  font-weight: bold;
}
.text-red {
  color: red
}
.margin-left-20px {
  margin-left: 20px
}
.margin-left-5px {
  margin-left: 5px
}

.header-style {
  display: flex;
  justify-content: center;
  align-items: center;
}
.style-button-section{
  margin-top: -26px;
}
.style-list-section {
  margin-top: 20px;
}
.style-select-options {
  margin-top: 10px;
}
.style-template-text {
  margin-top: 15px;
}
.style-new-icon {
  margin-left: 15px;
  margin-right: 16px;
}
</style>


// WEBPACK FOOTER //
// allRows.vue?34453bee